import { DB_TYPE } from '@quesmed/types';
import { EProductType } from '@quesmed/types/models';

/**
 * A station's `osceTypeId` field holds an `EOsceType` value for OSCE/PLAB2 stations but an
 * `EPaceType` value for PACES stations. `productId` isn't stored on the station itself, so when
 * it isn't known (e.g. the standalone edit-by-id page), fall back to the globally selected
 * `dbType` — `DB_TYPE.MRCP` uniquely identifies PACES among station-eligible products.
 */
export const isPacesProduct = (productId: EProductType | undefined, dbType: DB_TYPE): boolean =>
  productId ? productId === EProductType.PACES : dbType === DB_TYPE.MRCP;
